import React from "react";

import classnames from "classnames";
import simplifyPlanName from "Utils/simplifyPlanName";

import Button from "Common/Button";
import { CarrierLogo } from "Common/CarrierLogo";
import { ContentRow } from "Common/Table";

import makeBem from "Utils/makeBem";

const bem = makeBem("MultiplePlanHeader");

const MultiplePlanHeader = ({ plans, onClick }) => (
  <tbody>
    <ContentRow cell={(p) => <CarrierLogo plan={p} maxSize={3} />} items={plans} />

    <ContentRow cell={(p) => `${simplifyPlanName(p)}`} items={plans} />
    {plans.some((p) => p.hsa_eligible) && <ContentRow cell={(p) => (p.hsa_eligible ? "HSA Eligible" : "")} items={plans} />}
    <ContentRow
      cell={(p) => (
        <Button
          text="Enroll or Decline"
          size="medium"
          fullWidth
          className={classnames(bem("selectPlanButton"))}
          data-keyboard="true"
          onClick={(_) => onClick(p.id)}
        />
      )}
      items={plans}
    />
  </tbody>
);

export default MultiplePlanHeader;
